// extracted by mini-css-extract-plugin
export default {"updateUser":"UpdateUser_updateUser__B6ynx","nameGroup":"UpdateUser_nameGroup__jq8qx","formActions":"UpdateUser_formActions__iaSkF"};